/**
 * graph006
 */
export default class {

	constructor(selector, data) {
		this.ID = selector;
		this.DATA = data;

		// objects
		this.chart;

		// init
		this.buildGraph();
	}

	buildGraph() {
		if(!$(this.ID).length || (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() < 319)) return false;
		this.chart = this.Graph006(this.ID, this.DATA);

		// print event
		window.matchMedia("print").addListener(function() {
			if($('body').hasClass("is-modal--white-print") || !$(this.ID).is(":visible")) return;
			this.chart.resize();
			return false;
		});
	}

	heightGraph() {
		// fixed height
		return $('.c-graph-006__option').outerHeight(true) - $('.c-graph-006__option li:first-child').outerHeight(true) + 29;
	}

	Graph006(id, dataG006) {
		var dataColorG006 = {
			data1: '#13C959',
			data2: '#FDB900',
			data3: '#FF009D',
			data4: '#FF009D',
			data5: '#FF009D'
		};
		var i = 0;
		for(var k in dataColorG006) {
			i++;
			if(i <= dataG006.length) continue;
			delete dataColorG006[k];
		}

		return c3.generate({
			bindto: id,
			data: {
				columns: dataG006,
				type: 'bar',
				colors: dataColorG006,
				labels: {
					show: true,
					// add "%" for column
					format: {
//						data1: d3.format(''),
						data1: function (v, id, i, j) { return v + "%"; },
//						data2: d3.format(''),
						data2: function (v, id, i, j) { return v + "%"; },
//						data3: d3.format(''),
						data3: function (v, id, i, j) { return v + "%"; },
//						data4: d3.format(''),
						data4: function (v, id, i, j) { return v + "%"; },
//						data5: d3.format(''),
						data5: function (v, id, i, j) { return v + "%"; }
					}
				},
			},
			size: { height: Math.max(120, this.heightGraph()) },
			padding: { top: 0, left: 10, right: 0 },
			grid: {
				lines: { front: false },
				x: {
					tick: { rotate: 75 },
					show: false
				},
				y: {
					lines: [
						{ value: 0 },
						{ value: 10 },
						{ value: 20 },
						{ value: 30 },
						{ value: 40 },
						{ value: 50 },
						{ value: 60 },
						{ value: 70 },
						{ value: 80 },
						{ value: 90 },
						{ value: 100 }
					]
				}
			},
			axis: {
				rotated: true,
				x: {
					tick: { outer: false },
				},
				y: {
					tick: { outer: false },
					max: 100.1,
					min: 0,
					padding: { top: 0, bottom: 0, left: 0, right: 0 }
				}
			},
			bar: { width: 42, space: 0.78 },
			tooltip: { show: false },
			legend: { show: false },
			interaction: { enabled: false }
		});
	}
}
